import imageAnca from '../../assets/trattamenti/anca.jpg';
import BackgroundImgBlur from '../../components/BackgroundImgBlur';


export default function AncaBacino() {
    const ancaBacinoContent = <>
    <div data-aos="fade-zoom-in" data-aos-duration="1000" className={`text-lg mt-10 mb-16 text-white`} > 
        <ul className='text-left'>
            <li className="mb-5 pb-3 border-b-2 border-[#65806E]">
                <b>Fratture, Protesi, Impingement Femoro-Acetabolare:</b> <br/> Terapia manuale, esercizio terapeutico, tecar terapia, laser terapia.
            </li>
            <li className="mb-5 pb-3 border-b-2 border-[#65806E]">
            <b>Tendinopatie:</b>  <br/> Terapia manuale, esercizio terapeutico, tecar terapia, laser terapia.
            </li>
        </ul>
    </div>
    </>
    return <>
        <BackgroundImgBlur src={imageAnca} title={'ANCA / BACINO'} content={ancaBacinoContent} hscreen={true}/>
    </>
}